var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<tr>\n    <td class=\"mkts-cmpt-svgcht-no-results\">No Results</td>\n</tr>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/html/menuBar/autocompleteNoresults.html
// module id = 40
// module chunks = 0